// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branch-form-container {
     margin-top: 32px;
     width: 50%;
     max-width: 600px;
   }
   
   .branch-form {
     display: flex;
     flex-direction: column;
     gap: 20px;
   }
   
   .branch-form .form-group {
     display: flex;
     flex-direction: column;
     gap: 8px;
   }
   
   .branch-form .form-group label {
     font-size: 14px;
     font-weight: 600;
     color: #2d3748;
   }
   
   .branch-form .form-group input {
     padding: 12px 16px;
     border: 2px solid #e2e8f0;
     border-radius: 8px;
     font-size: 14px;
     transition: all 0.2s;
     outline: none;
   }
   
   .branch-form .form-group input:focus {
     border-color: #667eea;
     box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
   }
   
   .submit-button {
     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
     color: white;
     border: none;
     padding: 14px;
     border-radius: 8px;
     font-size: 16px;
     font-weight: 600;
     cursor: pointer;
     transition: transform 0.2s, box-shadow 0.2s;
     margin-top: 8px;
   }
   
   .submit-button:hover:not(:disabled) {
     transform: translateY(-2px);
     box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
   }
   
   .submit-button:active:not(:disabled) {
     transform: translateY(0);
   }
   
   .submit-button:disabled {
     opacity: 0.6;
     cursor: not-allowed;
   }
   
   .message {
     padding: 12px 16px;
     border-radius: 8px;
     margin-bottom: 20px;
     font-size: 14px;
     font-weight: 500;
   }
   
   .message.success {
     background-color: #c6f6d5;
     color: #22543d;
     border: 1px solid #9ae6b4;
   }
   
   .message.error {
     background-color: #fed7d7;
     color: #742a2a;
     border: 1px solid #fc8181;
   }`, "",{"version":3,"sources":["webpack://./src/components/AddBranchForm/AddBranchForm.css"],"names":[],"mappings":"AAAA;KACK,gBAAgB;KAChB,UAAU;KACV,gBAAgB;GAClB;;GAEA;KACE,aAAa;KACb,sBAAsB;KACtB,SAAS;GACX;;GAEA;KACE,aAAa;KACb,sBAAsB;KACtB,QAAQ;GACV;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,cAAc;GAChB;;GAEA;KACE,kBAAkB;KAClB,yBAAyB;KACzB,kBAAkB;KAClB,eAAe;KACf,oBAAoB;KACpB,aAAa;GACf;;GAEA;KACE,qBAAqB;KACrB,8CAA8C;GAChD;;GAEA;KACE,6DAA6D;KAC7D,YAAY;KACZ,YAAY;KACZ,aAAa;KACb,kBAAkB;KAClB,eAAe;KACf,gBAAgB;KAChB,eAAe;KACf,2CAA2C;KAC3C,eAAe;GACjB;;GAEA;KACE,2BAA2B;KAC3B,gDAAgD;GAClD;;GAEA;KACE,wBAAwB;GAC1B;;GAEA;KACE,YAAY;KACZ,mBAAmB;GACrB;;GAEA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,mBAAmB;KACnB,eAAe;KACf,gBAAgB;GAClB;;GAEA;KACE,yBAAyB;KACzB,cAAc;KACd,yBAAyB;GAC3B;;GAEA;KACE,yBAAyB;KACzB,cAAc;KACd,yBAAyB;GAC3B","sourcesContent":[".branch-form-container {\n     margin-top: 32px;\n     width: 50%;\n     max-width: 600px;\n   }\n   \n   .branch-form {\n     display: flex;\n     flex-direction: column;\n     gap: 20px;\n   }\n   \n   .branch-form .form-group {\n     display: flex;\n     flex-direction: column;\n     gap: 8px;\n   }\n   \n   .branch-form .form-group label {\n     font-size: 14px;\n     font-weight: 600;\n     color: #2d3748;\n   }\n   \n   .branch-form .form-group input {\n     padding: 12px 16px;\n     border: 2px solid #e2e8f0;\n     border-radius: 8px;\n     font-size: 14px;\n     transition: all 0.2s;\n     outline: none;\n   }\n   \n   .branch-form .form-group input:focus {\n     border-color: #667eea;\n     box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n   }\n   \n   .submit-button {\n     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n     color: white;\n     border: none;\n     padding: 14px;\n     border-radius: 8px;\n     font-size: 16px;\n     font-weight: 600;\n     cursor: pointer;\n     transition: transform 0.2s, box-shadow 0.2s;\n     margin-top: 8px;\n   }\n   \n   .submit-button:hover:not(:disabled) {\n     transform: translateY(-2px);\n     box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);\n   }\n   \n   .submit-button:active:not(:disabled) {\n     transform: translateY(0);\n   }\n   \n   .submit-button:disabled {\n     opacity: 0.6;\n     cursor: not-allowed;\n   }\n   \n   .message {\n     padding: 12px 16px;\n     border-radius: 8px;\n     margin-bottom: 20px;\n     font-size: 14px;\n     font-weight: 500;\n   }\n   \n   .message.success {\n     background-color: #c6f6d5;\n     color: #22543d;\n     border: 1px solid #9ae6b4;\n   }\n   \n   .message.error {\n     background-color: #fed7d7;\n     color: #742a2a;\n     border: 1px solid #fc8181;\n   }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
